import React, { useEffect } from "react";
import { usePopupContext } from "@/contexts/PopUp";
import { usePageContext } from "@/contexts/Page";
import { usePopUps } from "@/hooks/PopUp";
import { PopUpCta } from "./PopUpCta";

export const PopUp: React.FC = () => {
  const { isPopupVisible, popupContent, showPopup, hidePopup } =
    usePopupContext();
  const { locationPopUps, defaultPopUps } = usePopUps();
  const { pageType, slug } = usePageContext();

  const setPopUpContent = () => {
    if (pageType === "normal") {
      const defaultPopup = defaultPopUps[0];
      if (defaultPopup) {
        return defaultPopup;
      }
    } else if (pageType === "template" && slug) {
      if (typeof window !== "undefined") {
        const path = window.location.pathname;
        const pathSections = path.split("/").filter(Boolean);
        if (pathSections.length === 1) {
          const locationPopup = locationPopUps[slug]?.[0];
          if (locationPopup) {
            return locationPopup;
          }
        }
      }
    }
    return null;
  };

  const hasPopUpBeenShown = (popupId: string): boolean => {
    const shownPopUps = JSON.parse(
      sessionStorage.getItem("shownPopUps") || "[]"
    );
    return shownPopUps.includes(popupId);
  };

  const markPopUpAsShown = (popupId: string) => {
    const shownPopUps = JSON.parse(
      sessionStorage.getItem("shownPopUps") || "[]"
    );
    shownPopUps.push(popupId);
    sessionStorage.setItem("shownPopUps", JSON.stringify(shownPopUps));
  };

  useEffect(() => {
    const content = setPopUpContent();

    if (content) {
      if (!hasPopUpBeenShown(content.id)) {
        showPopup(
          <PopUpCta
            image={content.featuredImage}
            redirections={content.popupInformation.redirections}
          />
        );
        markPopUpAsShown(content.id);
      }
    } else {
      hidePopup();
    }
  }, [pageType, slug]);

  if (!isPopupVisible) return null;

  return (
    <div className="popup__overlay" onClick={hidePopup}>
      <button className="popup__button" onClick={hidePopup}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
        </svg>
      </button>
      <div className="popup__content" onClick={(e) => e.stopPropagation()}>
        {popupContent}
      </div>
    </div>
  );
};
